// eslint-disable-next-line
import { Nullable } from 'utils/types';

// Remove
//  - Accents
//  - Dieresis
//  - Ñuflo
export const normalizeStringWithSpecialCharacters = (
  value: Nullable<string>,
  replaceNuflo = false,
  skip = false
) => {
  if (!value || skip) return value;
  let r = value.toLowerCase();
  r = r.replace(new RegExp('[àáâãä]', 'g'), 'a');
  r = r.replace(new RegExp('[èéêẽë]', 'g'), 'e');
  r = r.replace(new RegExp('[ìíîïĩ]', 'g'), 'i');
  r = r.replace(new RegExp('[òóôöõ]', 'g'), 'o');
  r = r.replace(new RegExp('[ùúûüũ]', 'g'), 'u');
  r = r.replace(new RegExp('[ýÿ]', 'g'), 'y');
  r = replaceNuflo ? r.replace(new RegExp('ñ', 'g'), 'n') : r;
  return r;
};
